function FormLabel ({
  name,
  value,
  show = true,
  className = 'block text-gray-90 mb-1'
}) {
  if (!show) {
    return null
  }

  return (
    <label
      htmlFor={name}
      className={className}
    >
      {value}
    </label>
  )
}

export default FormLabel
